import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Staff from "./routes/Staff";
import Print from "./routes/Print";
import Wall from "./routes/Wall";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/staff" element={<Staff />} />
        <Route path="/staff/print" element={<Print />} />
        <Route path="/wall" element={<Wall />} />
        {/*
          Everything else goes to the wall.

          There are only two kinds of visitor left: an operator, who types
          /staff, and the projector, which is pointed at /wall once and never
          touched again. A stray URL on the venue machine landing on the wall
          is exactly right; landing on a 404 in front of the room is not.
        */}
        <Route path="*" element={<Navigate to="/wall" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
